import styled, { css } from 'styled-components';

const ContinueToVASStyled = styled.div.attrs({
  className: 'add-on__sticky-footer',
})`
  ${({ theme, ndiBanner }) => {
    const { colors, media } = theme;
    return css`
      background: ${colors.primary.white};
      padding-top: 1rem;
      bottom: 0;
      padding: 1rem 2rem 2rem;
      position: sticky;
      z-index: 9; // Show above product card swiper, but below nonprod debug bar

      ${media.mobile.down} {
        bottom: ${ndiBanner ? '73px' : '0'};
      }

      .add-on {
        &__disclaimer {
          text-align: center;
        }

        &__btn-continue {
          span {
            display: inline-flex;
          }
          svg {
            margin-left: 0.5rem;
          }
        }
      }
    `;
  }}
`;

export default ContinueToVASStyled;
